import ACTIONS from "../constants/actions";

const {
  GET_USERS_REQUEST,
  ADD_USERS_REQUEST,
  GET_USERS_REQUEST_FAIL,
  GET_USERS_REQUEST_SUCCESS,
  ADD_USERS_REQUEST_SUCCESS,
  ADD_USERS_REQUEST_FAIL,
  DEL_USERS_REQUEST,
  DEL_USERS_REQUEST_SUCCESS,
  DEL_USERS_REQUEST_FAIL,
  GET_USERS_BY_ID_REQUEST,
  GET_USERS_BY_ID_REQUEST_SUCCESS,
  GET_USERS_BY_ID_REQUEST_FAIL,
  UPDATE_USERS_REQUEST,
  UPDATE_USERS_REQUEST_SUCCESS,
  UPDATE_USERS_REQUEST_FAIL,
  GET_USER_SHIFT_TIME,
  GET_USER_SHIFT_TIME_FAIL,
  GET_USER_SHIFT_TIME_SUCCESS,
  GET_USERS_CHECKTIME_REQUEST,
  GET_USERS_CHECKTIME_SUCCESS,
  GET_USERS_CHECKTIME_FAIL,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_FAIL,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_BY_ID,
  CHANGE_USER_PASSWORD_BY_ID_SUCCESS,
  CHANGE_USER_PASSWORD_BY_ID_FAIL,
  GET_USER_ALL_BRANCHES,
  GET_USER_ALL_BRANCHES_SUCCESS,
  POST_USER_BRANCH_SUCCESS,
  POST_USER_BRANCH_FAIL,
  POST_USER_BRANCH,
  REMOVE_USER_BRANCH,
  REMOVE_USER_BRANCH_SUCCESS,
  REMOVE_USER_BRANCH_FAIL,
  UPDATE_RESIDENT_CARD,
  UPDATE_RESIDENT_CARD_SUCCESS,
  UPDATE_RESIDENT_CARD_FAIL,
  GET_TEAMS_REQUEST,
  GET_TEAMS_REQUEST_SUCCESS,
  GET_TEAMS_REQUEST_FAIL,
  UPDATE_EMERGENCY_CONTACT,
  UPDATE_EMERGENCY_CONTACT_SUCCESS,
  UPDATE_EMERGENCY_CONTACT_FAIL,
  GET_EMERGENCY_CONTACT_REQUEST,
  GET_EMERGENCY_CONTACT_REQUEST_FAIL,
  GET_EMERGENCY_CONTACT_REQUEST_SUCCESS,
  GET_USER_REPORT,
  GET_USER_REPORT_SUCCESS,
  GET_USER_REPORT_FAIL,
  GET_USER_SHIFT_OVERTIME,
  GET_USER_SHIFT_OVERTIME_SUCCESS,
  GET_USER_SHIFT_OVERTIME_FAIL,
  GET_ALL_JOB_TYPE,
  GET_ALL_JOB_TYPE_SUCCESS,
  GET_ALL_JOB_TYPE_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingShift: false,
  isLoadingGetUser: false,
  isLoadingGetShiftOvertime: false,
  isLoadingGetUserById: false,
  isLoadingGetUserChecktime: false,
  isLoadingUserAllBranches: false,
  isLoadingUpdateEmergencyContact: false,
  userAllBranches: [],
  listUsers: [],
  user: {},
  listUserShiftTime: [],
  listUserShiftOvertime: [],
  userChecktime: [],
  isChangingPassword: false,
  isLoadingTeam: false,
  team: [],
  emergencyContact: {},
  isLoadingGetUserReport: false,
  userReport: {},
  jobTypesList: [],
  isLoadingGetJobTypes: false,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return {
        ...state,
        isLoadingGetUser: true,
        pageData: {
          ...state.pages,
          ...action.pages,
        },
      };
    case GET_USERS_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingGetUser: false,
        listUsers: action.payload.contents,
        UsersTotalElements: action.payload.totalElements,
        UsersTotalPages: action.payload.totalPages,
      };
    case GET_USERS_REQUEST_FAIL:
      return {
        ...state,
        isLoadingGetUser: false,
        pageData: {
          ...state.pages,
          ...action.pages,
        },
      };
    case GET_ALL_JOB_TYPE:
      return {
        ...state,
        isLoadingGetJobTypes: true,
      };
    case GET_ALL_JOB_TYPE_SUCCESS:
      return {
        ...state,
        isLoadingGetJobTypes: false,
        jobTypesList: action.payload,
      };
    case GET_ALL_JOB_TYPE_FAIL:
      return {
        ...state,
        isLoadingGetJobTypes: false,
      };
    case ADD_USERS_REQUEST:
      return {
        ...state,
      };
    case ADD_USERS_REQUEST_SUCCESS:
      return {
        ...state,
      };
    case ADD_USERS_REQUEST_FAIL:
      return {
        ...state,
      };
    case DEL_USERS_REQUEST:
      return {
        ...state,
      };
    case DEL_USERS_REQUEST_SUCCESS:
      return {
        ...state,
      };
    case DEL_USERS_REQUEST_FAIL:
      return {
        ...state,
      };
    case GET_USERS_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingGetUserById: true,
      };
    case GET_USERS_BY_ID_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingGetUserById: false,
        user: action.payload,
      };
    case GET_USERS_BY_ID_REQUEST_FAIL:
      return {
        ...state,
        isLoadingGetUserById: false,
      };
    case UPDATE_USERS_REQUEST:
      return {
        ...state,
      };
    case UPDATE_USERS_REQUEST_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_USERS_REQUEST_FAIL:
      return {
        ...state,
      };
    case UPDATE_EMERGENCY_CONTACT:
      return {
        ...state,
        isLoadingUpdateEmergencyContact: true,
      };
    case UPDATE_EMERGENCY_CONTACT_SUCCESS:
      return {
        ...state,
        isLoadingUpdateEmergencyContact: false,
        emergencyContact: action.payload,
      };
    case UPDATE_EMERGENCY_CONTACT_FAIL:
      return {
        ...state,
        isLoadingUpdateEmergencyContact: false,
      };
    case GET_EMERGENCY_CONTACT_REQUEST:
      return {
        ...state,
      };
    case GET_EMERGENCY_CONTACT_REQUEST_FAIL:
      return {
        ...state,
      };
    case GET_EMERGENCY_CONTACT_REQUEST_SUCCESS:
      return {
        ...state,
        emergencyContact: action.payload,
      };
    case GET_USER_SHIFT_TIME:
      return {
        ...state,
        isLoadingShift: true,
      };
    case GET_USER_SHIFT_TIME_SUCCESS:
      return {
        ...state,
        isLoadingShift: false,
        listUserShiftTime: action.payload,
      };
    case GET_USER_SHIFT_TIME_FAIL:
      return {
        ...state,
        isLoadingShift: false,
      };
    case GET_USER_SHIFT_OVERTIME:
      return {
        ...state,
        isLoadingGetShiftOvertime: true,
      };
    case GET_USER_SHIFT_OVERTIME_SUCCESS:
      return {
        ...state,
        listUserShiftOvertime: action.payload,
        isLoadingGetShiftOvertime: false,
      };
    case GET_USER_SHIFT_OVERTIME_FAIL:
      return {
        ...state,
        isLoadingGetShiftOvertime: false,
      };
    case GET_USERS_CHECKTIME_REQUEST:
      return {
        ...state,
        isLoadingGetUserChecktime: true,
      };
    case GET_USERS_CHECKTIME_SUCCESS:
      return {
        ...state,
        isLoadingGetUserChecktime: false,
        userChecktime: action.payload,
      };
    case GET_USERS_CHECKTIME_FAIL:
      return {
        ...state,
        isLoadingGetUserChecktime: false,
      };
    case CHANGE_USER_PASSWORD:
      return {
        ...state,
      };
    case CHANGE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
      };
    case CHANGE_USER_PASSWORD_FAIL:
      return {
        ...state,
      };
    case CHANGE_USER_PASSWORD_BY_ID:
      return {
        ...state,
        isChangingPassword: true,
      };
    case CHANGE_USER_PASSWORD_BY_ID_SUCCESS:
      return {
        ...state,
        isChangingPassword: false,
      };
    case CHANGE_USER_PASSWORD_BY_ID_FAIL:
      return {
        ...state,
        isChangingPassword: false,
      };
    case GET_USER_ALL_BRANCHES:
      return {
        ...state,
        isLoadingUserAllBranches: true,
      };
    case GET_USER_ALL_BRANCHES_SUCCESS:
      return {
        ...state,
        isLoadingUserAllBranches: false,
        userAllBranches: action.payload,
      };
    case POST_USER_BRANCH:
      return {
        ...state,
      };
    case POST_USER_BRANCH_SUCCESS:
      return {
        ...state,
      };
    case POST_USER_BRANCH_FAIL:
      return {
        ...state,
      };
    case REMOVE_USER_BRANCH:
      return {
        ...state,
      };
    case REMOVE_USER_BRANCH_SUCCESS:
      return {
        ...state,
      };
    case REMOVE_USER_BRANCH_FAIL:
      return {
        ...state,
      };
    case UPDATE_RESIDENT_CARD:
      return { ...state };
    case UPDATE_RESIDENT_CARD_SUCCESS:
      return { ...state };
    case UPDATE_RESIDENT_CARD_FAIL:
      return { ...state };
    case GET_TEAMS_REQUEST:
      return {
        ...state,
        isLoadingTeam: true,
      };
    case GET_TEAMS_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingTeam: false,
        team: action.payload,
      };
    case GET_TEAMS_REQUEST_FAIL:
      return {
        ...state,
        isLoadingTeam: false,
      };

    case GET_USER_REPORT:
      return {
        ...state,
        isLoadingGetUserReport: true,
      };
    case GET_USER_REPORT_SUCCESS:
      return {
        ...state,
        isLoadingGetUserReport: false,
        userReport: action.payload,
      };
    case GET_USER_REPORT_FAIL:
      return {
        ...state,
        isLoadingGetUserReport: false,
      };

    default:
      return state;
  }
};
export default usersReducer;
